/**
 * BaseApiModel with common functions
 */

export class BaseApiModel {
	
	/**
	 * Returns the object as JSON string
	 */
	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}
	
}